import $ from 'jquery';
import gsap from 'gsap';
import dayjs from 'dayjs';
import menu from '../utils/menu';
import flatpickr from 'flatpickr';

const search = {
	rand: Math.floor(Math.random() * 1000) + 1,
	array_product: [],
	array_destination: [],
	array_transfers: [],
	calendar_module: [],
	participants: 1,
	participants_nb: 1,
	participants_anim: gsap.timeline(),
	type: 'home',
	container: null,
	calendar_id: null,
	participants_module: 1,
	fromMenu: false,
	modalTargetEnv: '_classic',
	activeSearchTab: 'places',

	init() {
		this.bindGlobalEvents();
		this.loadDestinations();
		this.setupFlatpickr();
		this.calendarSearch();
		this.participantsControl();
		this.participantsFieldControl();
		this.restoreLastSearch();
		this.restoreServerSearchDates();
	},

	isMobileSearch() {
		return window.matchMedia('(max-width: 767px)').matches;
	},

	bindGlobalEvents() {

		$(document).on('input', 'input[name=__search_destination_mobile]', e => {
			const value = e.currentTarget.value.trim();
			const $results = $('#modal_search_destination .__search_results_mobile');
			$('#modal_search_destination .__clear_modal_search').toggleClass('_show', value.length > 0);

			if (!value.length) {
				$results.html(this.renderMobileResultsHtml(this.getMobileDefaultSuggestions())).show();
				return;
			}

			if (value.length < 2) {
				$results.html('');
				return;
			}

			const results = this.searchInDestinations(value).filter(item => item.type === this.getMobileSuggestionType());
			$results.html(this.renderMobileResultsHtml(results)).show();
		});

		// Onglets "haut niveau" de la modal recherche mobile (Place/Activity,
		// When, Participants, Type of tour) - une seule section visible a la
		// fois au lieu de tout empiler a la suite, cf. retours utilisateur.
		$(document).on('click', '.__modal_search_outer_tab', e => {
			const $tab = $(e.currentTarget);
			const panel = $tab.data('searchPanel');

			if ($tab.hasClass('_active')) return;

			this.activateMobileSearchPanel(panel);
		});

		$(document).on('click', '.__modal_search_tab', e => {
			const $tab = $(e.currentTarget);
			const tab = $tab.data('searchTab');

			if (this.activeSearchTab === tab) return;

			this.activeSearchTab = tab;

			$('.__modal_search_tab').each(function () {
				const isActive = $(this).data('searchTab') === tab;
				$(this).toggleClass('_active', isActive)
					.attr('aria-selected', String(isActive))
					.attr('tabindex', isActive ? '0' : '-1');
			});

			const $input = $('#modal_search_destination input[name=__search_destination_mobile]');
			const $results = $('#modal_search_destination .__search_results_mobile');
			const value = $input.val().trim();

			if (!value.length) {
				$results.html(this.renderMobileResultsHtml(this.getMobileDefaultSuggestions())).show();
				return;
			}

			const results = this.searchInDestinations(value).filter(item => item.type === this.getMobileSuggestionType());
			$results.html(this.renderMobileResultsHtml(results)).show();
		});

		$(document).on('click', '.__mobile_result_item', e => {
			e.preventDefault();

			const $item = $(e.currentTarget);

			this.selectMobileSuggestion({
				id: String($item.data('id')),
				type: String($item.data('type')),
				title: String($item.data('title') || '')
			});
		});

		// Pastilles du recap (cf. updateSearchRecap()) : cliquer une pastille
		// retire uniquement le critere qu'elle represente, plutot que de tout
		// reinitialiser - cf. retours utilisateur.
		$(document).on('click', '.__modal_search_recap_item', e => {
			e.preventDefault();

			const $item = $(e.currentTarget);
			const type = $item.data('recapType');
			const c = this.getContainer('_mobile_bar');

			if (type === 'tour_type') {
				const value = $item.data('recapValue');
				$(`#modal_search_destination .__modal_type_checkbox[value="${value}"]`)
					.prop('checked', false)
					.trigger('change');
				// Le handler "change" ci-dessus resynchronise la vraie case a
				// cocher et rappelle deja updateMobileModalSearchButton()/
				// updateSearchRecap() - inutile de les rappeler une seconde fois.
				return;
			}

			if (type === 'destination') {
				const target = this.getContainer(this.modalTargetEnv || '_classic');
				const clearDest = ($c) => {
					$c.find('input[name=destination_id], input[name=category_id], input[name=destination_type], input[name=__search_destination]').val('');
					$c.find('._clear_destination').removeClass('_show');
				};
				clearDest(target);
				if (this.modalTargetEnv !== '_mobile_bar') {
					const $mb = this.getContainer('_mobile_bar');
					if ($mb.length) clearDest($mb);
				}

				$('#modal_search_destination input[name=__search_destination_mobile]').val('');
				$('#modal_search_destination .__clear_modal_search').removeClass('_show');

				const $results = $('#modal_search_destination .__search_results_mobile');
				$results.html(this.renderMobileResultsHtml(this.getMobileDefaultSuggestions())).show();
			} else if (type === 'date') {
				this.clearCalendar('_mobile_bar');
			} else if (type === 'participants') {
				c.find('input[name=__search_participants]').val(2);

				const $participantsField = $('#modal_search_destination ._participants_field[data-env="_mobile_bar"]');
				$participantsField.find('._step_number').text(2);
				$participantsField.find('._step_word').text('Participants');
				$participantsField.find('.__step_btn._minus').addClass('_inactiv');
			}

			this.updateMobileModalSearchButton();
			this.updateSearchRecap();
		});

		$(document).on('click', '.__mobile_modal_reset_btn', e => {
			e.preventDefault();
			this.resetMobileSearchFilters();
		});

		$(document).on('click', '.__clear_modal_search', e => {
			e.preventDefault();

			const $input = $('#modal_search_destination input[name=__search_destination_mobile]');
			$input.val('').trigger('input').focus();
		});

		$(document).on('click', '.__mobile_search_trigger, .__open_modal_search[data-type="destination"]', e => {
			e.preventDefault();

			const env = $(e.currentTarget).data('env') || '_classic';
			this.openDestinationModal(env);
		});

		$(document).on('click', '.__open_modal_search[data-type="calendar"]', e => {
			e.preventDefault();

			const env = $(e.currentTarget).data('env') || '_classic';
			this.calendar_id = $(e.currentTarget).attr('id');
			this.container = this.getContainer(env);
			$('#modal_search_calendar').addClass('_show');
		});

		$(document).on('click', '.__close_modal_search', e => {
			e.preventDefault();
			$('.__modal_search').removeClass('_show');
		});

		// $(window).on('click', () => {
		// 	$('._search_warning, ._search_empty').removeClass('_show');
		// });
		//
		// $(document).on('focus', 'input', () => {
		// 	$('._search_warning, ._search_empty').removeClass('_show');
		// });

		$(document).on('click', '.__search_module', () => {
			menu.search = true;
			$('#modal_search_desktop').addClass('_show');
			$('html,body').addClass('_overflow');
		});

		// TYPE OF TOUR (modales desktop/mobile, cf. PARTS/_ophorus_search_type_field).
		// Deux rendus differents selon la modal :
		// - modal recherche mobile plein ecran : repli/depli EN FLUX (pousse le
		//   contenu en dessous), meme pattern que ._promo_toggle sur le recap du
		//   checkout ;
		// - modal recherche desktop centree (--centered) : popup flottant
		//   PAR-DESSUS le reste des champs (position absolute, ne pousse rien),
		//   meme principe que "When ?" juste en dessous - pas de slideDown/
		//   slideUp ici, seulement une classe ._show (cf. retours utilisateur
		//   "comme destination").
		$(document).on('click', '.__modal_type_toggle', function (e) {
			const $btn = $(this);
			const $panel = $('#' + $btn.attr('aria-controls'));
			const expanded = $btn.attr('aria-expanded') === 'true';

			if ($btn.closest('.--centered').length) {
				e.stopPropagation();
				$('.__modal_type_list').removeClass('_show');
				$('.__modal_type_toggle').removeClass('_open').attr('aria-expanded', 'false')
					.find('.__arrow').addClass('_down').removeClass('_up');
				$('.__modal_when_popup').removeClass('_show');
				$('.__modal_when_toggle').removeClass('_open').attr('aria-expanded', 'false');

				if (!expanded) {
					$panel.addClass('_show');
					$btn.attr('aria-expanded', 'true').addClass('_open')
						.find('.__arrow').removeClass('_down').addClass('_up');
				}
				return;
			}

			$panel.stop(true, true)[expanded ? 'slideUp' : 'slideDown'](250);
			$btn.attr('aria-expanded', (!expanded).toString());
			$btn.find('.__arrow').toggleClass('_down', expanded).toggleClass('_up', !expanded);
			// Classe en plus de [aria-expanded] pour la rotation de la fleche
			// (cf. _ophorus_modals.scss) : le selecteur d'attribut seul ne
			// declenchait pas de reflow fiable du "transform" sur certains
			// environnements de rendu.
			$btn.toggleClass('_open', !expanded);
		});

		// "When ?" (modal recherche desktop) - popup flottant PAR-DESSUS le
		// reste des champs (position absolute, ne pousse rien), meme principe
		// que ._calendar_inline sur l'accueil plutot qu'un panneau en flux.
		$(document).on('click', '.__modal_when_toggle', function (e) {
			e.stopPropagation();
			const $btn = $(this);
			const $panel = $('#' + $btn.attr('aria-controls'));
			const wasOpen = $panel.hasClass('_show');

			$('.__modal_when_popup').removeClass('_show');
			$('.__modal_when_toggle').removeClass('_open').attr('aria-expanded', 'false');
			$('.__modal_type_list').removeClass('_show');
			$('.__modal_type_toggle').removeClass('_open').attr('aria-expanded', 'false')
				.find('.__arrow').addClass('_down').removeClass('_up');

			if (!wasOpen) {
				$panel.addClass('_show');
				$btn.addClass('_open').attr('aria-expanded', 'true');
			}
		});

		$(document).on('click', e => {
			if (!$(e.target).closest('.__modal_when_popup, .__modal_when_toggle').length) {
				$('.__modal_when_popup').removeClass('_show');
				$('.__modal_when_toggle').removeClass('_open').attr('aria-expanded', 'false');
			}

			// "Type of tour" - se referme aussi au clic ailleurs (une fois la
			// selection faite, cf. retours utilisateur "on peut fermer"), pas
			// seulement en re-cliquant le bouton.
			if (!$(e.target).closest('.__modal_type_field').length) {
				const $openToggle = $('.__modal_type_toggle[aria-expanded="true"]');
				if ($openToggle.length) {
					if ($openToggle.closest('.--centered').length) {
						$('#' + $openToggle.attr('aria-controls')).removeClass('_show');
						$openToggle.attr('aria-expanded', 'false').removeClass('_open')
							.find('.__arrow').addClass('_down').removeClass('_up');
						return;
					}
					$('#' + $openToggle.attr('aria-controls')).stop(true, true).slideUp(200);
					$openToggle.attr('aria-expanded', 'false').removeClass('_open')
						.find('.__arrow').addClass('_down').removeClass('_up');
				}
			}
		});

		// Les puces de la modal ne portent pas name="type[]" (purement visuelles) :
		// on synchronise leur etat vers les vraies cases a cocher du formulaire
		// cible (cf. getContainer()), celles que check()/submit() lisent
		// reellement, et on met a jour le libelle du bouton replie/deplie.
		$(document).on('change', '.__modal_type_checkbox', function () {
			const $checkbox = $(this);
			const env = $checkbox.data('env');
			const value = $checkbox.val();

			search.getContainer(env)
				.find(`input[name="type[]"][value="${value}"]`)
				.prop('checked', $checkbox.prop('checked'));

			const $panel = $checkbox.closest('.__modal_type_list');
			const $toggle = $panel.prev('.__modal_type_toggle');
			const checked = $panel.find('.__modal_type_checkbox:checked');

			if (!checked.length) {
				$toggle.find('.__modal_type_toggle_label').text('Any type');
			} else if (checked.length === 1) {
				$toggle.find('.__modal_type_toggle_label').text(checked.data('label'));
			} else {
				$toggle.find('.__modal_type_toggle_label').text(checked.length + ' types selected');
			}

			search.updateMobileModalSearchButton();
			search.updateSearchRecap();
		});

		$(document).on('click', '._cancel_search', () => {
			menu.closeSub();
		});

		// $(document).on('click', '._close_empty', () => {
		// 	$('._search_empty').removeClass('_show');
		// });

		$(document).on('click', '.--search_btn', e => {
			e.preventDefault();

			const type = $(e.currentTarget).data('btn');
			this.container = this.getContainer(type);

			const isValid = this.check(false, type);

			if (!isValid) {
				this.container.find('._search_warning').addClass('_show');
				setTimeout(() => $('._search_warning').removeClass('_show'), 3000);
				return;
			}

			this.submit(false, $(e.currentTarget).hasClass('_module'));
		});

		$(document).on('click', '._clear_destination', e => {
			e.preventDefault();

			const env = $(e.currentTarget).data('env');
			this.container = this.getContainer(env);

			this.container.find('input[name=destination_id]').val('');
			this.container.find('input[name=destination_type]').val('');
			this.container.find('input[name=category_id]').val('');
			this.container.find('input[name=__search_destination]').val('');
			this.container.find('._clear_destination').removeClass('_show');

			const input = this.container.find('input[name=__search_destination]')[0];
			if (input) {
				this.showPopular(input);
				input.focus();
			}

			this.updateMobileModalSearchButton();
			this.updateSearchRecap();
		});

		$(document).on('click', '._search_dropdown_item', e => {
			e.preventDefault();

			const $item = $(e.currentTarget);
			const env = String($item.data('env'));
			const id = String($item.data('id'));
			const type = String($item.data('type'));
			const title = String($item.data('title') || '');

			this.selectSuggestion(env, {id, type, title});
		});

		$(document).on('focus', 'input._autocomplete[data-type="destination"]', e => {
			e.stopPropagation();

			const input = e.currentTarget;
			const value = input.value.trim();

			if (!value.length) {
				this.showPopular(input);
			} else if (value.length >= 2) {
				const results = this.searchInDestinations(value);
				this.showResults(input, results);
			}
		});

		$(document).on('input', 'input._autocomplete[data-type="destination"]', e => {
			const input = e.currentTarget;
			const value = input.value.trim();
			const env = $(input).data('env');

			this.container = this.getContainer(env);
			this.container.find('input[name=destination_id]').val('');
			this.container.find('input[name=destination_type]').val('');
			this.container.find('input[name=category_id]').val('');

			if (value.length === 0) {
				this.container.find('._clear_destination').removeClass('_show');
				this.showPopular(input);
				return;
			}

			this.container.find('._clear_destination').addClass('_show');

			if (value.length < 2) {
				this.hideDropdown(input);
				return;
			}

			const results = this.searchInDestinations(value);
			this.showResults(input, results);
		});

		$(document).on('click', e => {
			if (
				!$(e.target).closest('.module-search').length &&
				!$(e.target).closest('#modal_search_mobile').length
			) {
				this.closeAllDropdowns();
			}
		});
	},

	renderMobileResultsHtml(items) {
		if (!items.length) {
			return '<div class="_no_result">No suggestions found</div>';
		}

		return items.map(item => {
			const title = item.title || '';
			const label = item.label || '<span>' + this.escapeHtml(title) + '</span>';

			return `
			<button type="button"
					class="__mobile_result_item"
					data-id="${item.id}"
					data-type="${item.type}"
					data-title="${this.escapeHtmlAttr(title)}">
				${label}
			</button>
		`;
		}).join('');
	},

	getContainer(env) {
		return $(`.__ophorus_search_module.${env}`).first();
	},

	openDestinationModal(env) {
		this.modalTargetEnv = env;
		this.container = this.getContainer(env);

		$('#modal_search_destination').addClass('_show');

		const $input = $('#modal_search_destination input[name=__search_destination_mobile]');
		const $results = $('#modal_search_destination .__search_results_mobile');

		const prefill = this.container.find('input[name=__search_destination]').val() || '';
		$input.val(prefill);
		$('#modal_search_destination .__clear_modal_search').toggleClass('_show', prefill.length > 0);

		// Repart toujours sur l'onglet "Place / Activity" a l'ouverture, meme si
		// un autre onglet (When, Participants, Type of tour) etait actif lors
		// d'une ouverture precedente.
		this.activateMobileSearchPanel('destination');

		// Repart toujours sur l'onglet "Places" a l'ouverture, meme si l'onglet
		// "Activities" avait ete choisi lors d'une ouverture precedente.
		this.activeSearchTab = 'places';
		$('#modal_search_destination .__modal_search_tab').each(function () {
			const isActive = $(this).data('searchTab') === 'places';
			$(this).toggleClass('_active', isActive)
				.attr('aria-selected', String(isActive))
				.attr('tabindex', isActive ? '0' : '-1');
		});

		$results.html(this.renderMobileResultsHtml(this.getMobileDefaultSuggestions())).show();

		// Reaffiche la valeur participants deja choisie (le champ de la modal
		// est independant de celui du formulaire cible, cf. participantsFieldControl()).
		const participants = parseInt(this.container.find('input[name=__search_participants]').val(), 10) || 2;
		const $participantsField = $('#modal_search_destination ._participants_field[data-env="' + env + '"]');
		$participantsField.find('input[name=__search_participants]').val(participants);
		$participantsField.find('._step_number').text(participants);
		$participantsField.find('._step_word').text(participants > 1 ? 'Participants' : 'Participant');
		$participantsField.find('.__step_btn._minus').toggleClass('_inactiv', participants <= 2);

		this.updateMobileModalSearchButton();
		this.updateSearchRecap();
	},

	activateMobileSearchPanel(panel) {
		let activeTab = null;

		$('#modal_search_destination .__modal_search_outer_tab').each(function () {
			const isActive = $(this).data('searchPanel') === panel;
			$(this).toggleClass('_active', isActive)
				.attr('aria-selected', String(isActive))
				.attr('tabindex', isActive ? '0' : '-1');

			if (isActive) {
				activeTab = this;
			}
		});

		$('#modal_search_destination .__modal_search_panel').each(function () {
			const isActive = $(this).attr('id') === '__modal_panel_' + panel;
			$(this).toggleClass('_active', isActive).prop('hidden', !isActive);
		});

		if (activeTab) {
			window.requestAnimationFrame(() => {
				activeTab.scrollIntoView({
					behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth',
					block: 'nearest',
					inline: 'center'
				});
			});
		}
	},

	activateNextMobileSearchPanel(env, panel) {
		if (env !== '_mobile_bar' || !$('#modal_search_destination').hasClass('_show')) return;

		this.activateMobileSearchPanel(panel);
	},

	getMobileSuggestionType() {
		return this.activeSearchTab === 'activities' ? 'AC' : 'VI';
	},

	getMobileDefaultSuggestions() {
		const type = this.getMobileSuggestionType();
		return this.sortByPopularScore(
			this.array_destination.filter(item => item.type === type)
		).slice(0, 8);
	},

	// Le bouton "Search" reste toujours visible en bas de la modal (cf.
	// .__modal_search_sticky_btn) - seul son etat active/desactive change,
	// une fois qu'au moins un critere de recherche est renseigne (place,
	// activite, date ou type of tour). Le nombre de participants seul ne
	// suffit pas (valeur par defaut deja non vide, cf. retours utilisateur).
	updateMobileModalSearchButton() {
		const $btn = $('#modal_search_destination .__mobile_modal_search_btn');
		if (!$btn.length) return;

		const c = this.getContainer($btn.data('btn'));
		const hasDestination = !!c.find('input[name=destination_id]').val();
		const hasCategory = !!c.find('input[name=category_id]').val();
		const hasDate = !!c.find('input[name=date_deb]').val();
		const hasType = c.find("input[name='type[]']:checked").length > 0;

		const isValid = hasDestination || hasCategory || hasDate || hasType;

		$btn.toggleClass('_disabled', !isValid).prop('disabled', !isValid);
	},

	// Persiste les criteres de la derniere recherche (sessionStorage) pour
	// les retrouver au prochain passage sur la modal - une recherche envoie
	// vers une nouvelle page (destination, resultats...) qui repart d'un DOM
	// vierge, sans quoi les filtres choisis seraient perdus a chaque fois,
	// cf. retours utilisateur.
	saveLastSearch(data) {
		try {
			sessionStorage.setItem('ophorus_last_search', JSON.stringify(data));
		} catch (e) {
			// Stockage indisponible (navigation privee, quota...) - la
			// recherche elle-meme reste fonctionnelle, seule la persistance
			// des filtres est perdue.
		}
	},

	restoreServerSearchDates() {
		const dates = window._SEARCH_DATES;
		if (!dates || !dates.date_deb) return;

		const formatted = dayjs(dates.date_deb).format('MMM DD, YYYY');

		['_classic', '_menu_top', '_mobile_bar'].forEach(env => {
			const $container = this.getContainer(env);
			if (!$container.length) return;

			$container.find('input[name=date_deb]').val(dates.date_deb);
			$container.find('input[name=__search_date]').val(formatted);
			$container.find('.__modal_field_text').text(formatted);

			const calendar = this.calendar_module.find(item => item.type === env);
			if (calendar) calendar.instance.setDate(new Date(dates.date_deb + 'T00:00:00'), false);
		});

		this.updateMobileModalSearchButton();
		this.updateSearchRecap();
		this.activateMobileSearchPanel('when');
	},

	restoreLastSearch() {
		let saved;
		try {
			saved = JSON.parse(sessionStorage.getItem('ophorus_last_search') || 'null');
		} catch (e) {
			saved = null;
		}
		if (!saved) return;

		const c = this.getContainer('_mobile_bar');

		if (saved.dest_id) c.find('input[name=destination_id]').val(saved.dest_id);
		if (saved.category_id) c.find('input[name=category_id]').val(saved.category_id);
		if (saved.dest_type) c.find('input[name=destination_type]').val(saved.dest_type);
		if (saved.destination_title) c.find('input[name=__search_destination]').val(saved.destination_title);
		if (saved.date_deb) c.find('input[name=date_deb]').val(saved.date_deb);
		if (saved.date_end) c.find('input[name=date_end]').val(saved.date_end);
		if (saved.participants) c.find('input[name=__search_participants]').val(saved.participants);

		if (Array.isArray(saved.type)) {
			saved.type.forEach(value => {
				c.find(`input[name='type[]'][value="${value}"]`).prop('checked', true);
				$(`#modal_search_destination .__modal_type_checkbox[value="${value}"]`).prop('checked', true);
			});
		}

		this.updateMobileModalSearchButton();
	},

	// Recap des criteres deja renseignes, affiche au-dessus du bouton Search
	// (cf. .__modal_search_recap) - chaque critere vit maintenant dans son
	// propre onglet (When, Participants, Type of tour...) et n'est donc plus
	// visible en meme temps que les autres, cf. retours utilisateur.
	updateSearchRecap() {
		const $recap = $('#modal_search_destination .__modal_search_recap');
		if (!$recap.length) return;
		const $actions = $('#modal_search_destination .__modal_search_actions');

		const c = this.getContainer('_mobile_bar');
		const items = [];

		const destination = $('#modal_search_destination input[name=__search_destination_mobile]').val().trim();
		if (destination) items.push({type: 'destination', label: destination});

		const dateDeb = c.find('input[name=date_deb]').val();
		if (dateDeb) items.push({type: 'date', label: dayjs(dateDeb).format('MMM D, YYYY')});

		const participants = parseInt(c.find('input[name=__search_participants]').val(), 10) || 2;
		if (participants > 2) items.push({type: 'participants', label: participants + ' Participants'});

		$('#modal_search_destination .__modal_type_checkbox:checked').each(function () {
			items.push({type: 'tour_type', value: $(this).val(), label: $(this).data('label')});
		});

		if (!items.length) {
			$recap.removeClass('_show').empty();
			$actions.removeClass('_has_filters');
			return;
		}

		// Chaque pastille est cliquable et retire uniquement son propre critere
		// (cf. handler ".__modal_search_recap_item" plus haut) - ce n'est pas
		// juste un indicateur passif, cf. retours utilisateur.
		const html = items.map(item => `
			<button type="button" class="__modal_search_recap_item" data-recap-type="${item.type}"${item.value !== undefined ? ` data-recap-value="${item.value}"` : ''}>
				<span>${this.escapeHtml(item.label)}</span>
				<span class="__modal_search_recap_remove" aria-hidden="true">&times;</span>
			</button>
		`).join('');
		$recap.addClass('_show').html(html);
		$actions.addClass('_has_filters');
	},

	resetMobileSearchFilters() {
		const c = this.getContainer('_mobile_bar');
		const target = this.getContainer(this.modalTargetEnv || '_classic');

		target.find('input[name=destination_id], input[name=category_id], input[name=destination_type], input[name=__search_destination]').val('');
		target.find('._clear_destination').removeClass('_show');
		c.find('input[name=destination_id], input[name=category_id], input[name=destination_type], input[name=__search_destination]').val('');
		c.find('._clear_destination').removeClass('_show');

		$('#modal_search_destination input[name=__search_destination_mobile]').val('');
		$('#modal_search_destination .__clear_modal_search').removeClass('_show');

		this.clearCalendar('_mobile_bar');

		c.find('input[name=__search_participants]').val(2);
		const $participantsField = $('#modal_search_destination ._participants_field[data-env="_mobile_bar"]');
		$participantsField.find('input[name=__search_participants]').val(2);
		$participantsField.find('._step_number').text(2);
		$participantsField.find('._step_word').text('Participants');
		$participantsField.find('.__step_btn._minus').addClass('_inactiv');

		$('#modal_search_destination .__modal_type_checkbox').prop('checked', false);
		c.find('input[name="type[]"]').prop('checked', false);
		$('#modal_search_destination .__modal_type_toggle_label').text('Any type');

		$('#modal_search_destination .__search_results_mobile')
			.html(this.renderMobileResultsHtml(this.getMobileDefaultSuggestions()))
			.show();

		this.updateMobileModalSearchButton();
		this.updateSearchRecap();
		this.activateMobileSearchPanel('destination');
	},

	getDropdown(input) {
		const env = $(input).data('env');
		return $(`.__search_dropdown[data-env="${env}"]`).first();
	},

	getPopularList(input) {
		return this.getDropdown(input).find('.__search_popular_list');
	},

	getResultsBox(input) {
		return this.getDropdown(input).find('.__search_results');
	},

	closeAllDropdowns() {
		$('.__search_dropdown').removeClass('_show');
		$('.__search_results').hide().html('');
		$('.__search_popular').show();
	},

	hideDropdown(input) {
		const $dropdown = this.getDropdown(input);
		$dropdown.removeClass('_show');
	},

	renderMobileResultsHtml(items) {
		if (!items.length) {
			return '<div class="_no_result">No suggestions found</div>';
		}

		return items.map(item => `
		<button type="button"
				class="__mobile_result_item"
				data-id="${item.id}"
				data-type="${item.type}"
				data-title="${this.escapeHtmlAttr(item.title || '')}">
			${item.label || `<span>${this.escapeHtml(item.title || '')}</span>`}
		</button>
	`).join('');
	},

	selectMobileSuggestion(item) {
		const $target = this.getContainer(this.modalTargetEnv || '_classic');
		const $modal = $('#modal_search_destination');

		const cleanTitle = this.formatSuggestionTitle(item.title);

		$modal.find('input[name=__search_destination_mobile]').val(cleanTitle);
		$modal.find('.__clear_modal_search').toggleClass('_show', cleanTitle.length > 0);

		const fillContainer = ($c) => {
			$c.find('input[name=__search_destination]').val(cleanTitle);
			if (item.type === 'AC') {
				$c.find('input[name=category_id]').val(item.id);
				$c.find('input[name=destination_id]').val('');
				$c.find('input[name=destination_type]').val(item.type);
			} else {
				$c.find('input[name=destination_id]').val(item.id);
				$c.find('input[name=category_id]').val('');
				$c.find('input[name=destination_type]').val(item.type);
			}
			$c.find('._clear_destination').addClass('_show');
		};

		fillContainer($target);

		if (this.modalTargetEnv !== '_mobile_bar') {
			const $mb = this.getContainer('_mobile_bar');
			if ($mb.length) fillContainer($mb);
		}

		$modal.find('.__search_results_mobile').hide().html('');

		this.updateMobileModalSearchButton();
		this.updateSearchRecap();
		this.activateMobileSearchPanel('when');
	},

	showPopular(input) {
		const $dropdown = this.getDropdown(input);
		const $popularBlock = $dropdown.find('.__search_popular');
		const $results = this.getResultsBox(input);


		if (!$dropdown.length) return;

		$dropdown.addClass('_show');
		$popularBlock.show();
		$results.hide().html('');
	},

	showResults(input, results) {
		const $dropdown = this.getDropdown(input);
		const $popularBlock = $dropdown.find('.__search_popular');
		const $results = this.getResultsBox(input);
		const env = $(input).data('env');

		if (!$dropdown.length || !$results.length) return;

		$dropdown.addClass('_show');
		$popularBlock.hide();

		if (!results.length) {
			$results.html('<div class="_no_result">No suggestions found</div>').show();
			return;
		}


		const html = results.map(item => `
			<button type="button"
					class="_search_dropdown_item"
					data-env="${env}"
					data-id="${item.id}"
					data-type="${item.type}"
					data-title="${this.escapeHtmlAttr(item.title || '')}">
				${item.label || `<span class="_txt"><strong>${this.escapeHtml(item.title || '')}</strong></span>`}
			</button>
		`).join('');

		$results.html(html).show();
	},

	loadDestinations() {
		$.getJSON(`${_SITE_URL}JSON/search_results_destinations.json?v=${this.rand}`, data => {
			this.array_destination = Array.isArray(data) ? data : [];

			document.querySelectorAll('input._autocomplete[data-type="destination"]').forEach(input => {
				this.renderPopularSearches(input);
			});
		});
	},

	sortByPopularScore(items) {
		return items
			.filter(item => Number(item.popular_score || 0) > 0)
			.sort((a, b) => Number(b.popular_score || 0) - Number(a.popular_score || 0));
	},

	renderPopularSearches(input) {
		const $box = this.getPopularList(input);
		if (!$box.length) return;

		const env = $(input).data('env');

		const destinations = this.sortByPopularScore(
			this.array_destination.filter(item => item.type === 'VI')
		).slice(0, 4);

		const categories = this.sortByPopularScore(
			this.array_destination.filter(item => item.type === 'AC')
		).slice(0, 4);

		const suggestions = [...destinations, ...categories];

		if (!suggestions.length) {
			$box.html('');
			return;
		}

		const html = suggestions.map(item => `
		<button type="button"
				class="_search_dropdown_item"
				data-env="${env}"
				data-id="${item.id}"
				data-type="${item.type}"
				data-title="${this.escapeHtmlAttr(item.title || '')}">
			${item.label || `<span>${this.escapeHtml(item.title || '')}</span>`}
		</button>
	`).join('');

		$box.html(html);
	},

	searchInDestinations(term) {
		const value = this.stripDiacritics(term.trim().toLowerCase());

		return this.array_destination.filter(item => {
			const haystack = this.stripDiacritics([
				item.value || '',
				item.title || '',
				this.stripHtml(item.label || '')
			].join(' ').toLowerCase());

			return haystack.includes(value);
		}).slice(0, 8);
	},

	selectSuggestion(env, item) {
		this.container = this.getContainer(env);
		const $input = this.container.find('input[name=__search_destination]');

		$input.val(this.formatSuggestionTitle(item.title));

		if (item.type === 'AC') {
			this.container.find('input[name=category_id]').val(item.id);
			this.container.find('input[name=destination_id]').val('');
			this.container.find('input[name=destination_type]').val(item.type);
		} else {
			this.container.find('input[name=destination_id]').val(item.id);
			this.container.find('input[name=category_id]').val('');
			this.container.find('input[name=destination_type]').val(item.type);
		}

		this.container.find('._clear_destination').addClass('_show');
		this.closeAllDropdowns();
	},

	extractSvgFromLabel(label) {
		if (!label) return '';
		const match = label.match(/<svg[\s\S]*?<\/svg>/i);
		return match ? match[0] : '';
	},

	formatSuggestionTitle(title) {
		if (!title) return '';
		const clean = String(title).split(',')[0].trim();
		// Les titres viennent de JSON/__ser (donnee generee, cf. CLAUDE.md) et y
		// sont stockes tout en majuscules ("PARIS, FRANCE") - on les remet en
		// casse normale uniquement pour l'affichage dans le champ, sans toucher
		// a la donnee source ni aux id/type envoyes au submit.
		return clean.toLowerCase().replace(/(^|[\s'-])\p{L}/gu, c => c.toUpperCase());
	},

	stripDiacritics(str) {
		return str.normalize('NFD').replace(/[̀-ͯ]/g, '');
	},

	stripHtml(str) {
		return String(str || '').replace(/<[^>]*>/g, ' ');
	},

	escapeHtml(str) {
		return String(str)
			.replace(/&/g, '&amp;')
			.replace(/</g, '&lt;')
			.replace(/>/g, '&gt;')
			.replace(/"/g, '&quot;')
			.replace(/'/g, '&#039;');
	},

	escapeHtmlAttr(str) {
		return this.escapeHtml(str).replace(/`/g, '&#096;');
	},

	setupFlatpickr() {
		document.querySelectorAll('.__search_calendar').forEach(el => {
			const instance = flatpickr(el, {
				nextArrow: '<svg class="_ic_lucide"><use xlink:href="#__ic_chevron_lucide"/></svg>',
				prevArrow: '<svg class="_ic_lucide _inverse"><use xlink:href="#__ic_chevron_lucide"/></svg>',
				inline: true,
				mode: 'single',
				minDate: 'today',
				dateFormat: 'M j, Y',
				locale: {firstDayOfWeek: 1},
				onReady: (selectedDates, dateStr, inst) => {
					this.calendar_module.push({type: el.dataset.env, instance: inst});
					inst.calendarContainer.classList.add('_search_module', 'calendarNormal');
				},
				onChange: (selectedDates, dateStr) => {
					const env = el.dataset.env;
					this.container = this.getContainer(env);

					this.container.find('._choose_date').removeClass('_activ _no_valid');
					this.container.find('._btn_plus').removeClass('_activ _no_valid');
					this.container.find(`#${this.calendar_id}`).val(dateStr);

					if (selectedDates[0]) {
						// dayjs().format() lit l'heure locale, contrairement a
					// toISOString() qui convertit en UTC - en France l'ete
					// (UTC+2), minuit local pour un jour choisi bascule sur la
					// VEILLE une fois converti en UTC, decalant la date d'un jour.
					this.container.find('input[name=date_deb]').val(dayjs(selectedDates[0]).format('YYYY-MM-DD'));
					}

					if (el.closest('#modal_search_calendar')) {
						$('#modal_search_calendar').removeClass('_show');
					}

					// Popup "When ?" de la modal recherche desktop (cf.
					// #modal_search_desktop) : affiche la date choisie a la place
					// de "When ?" et referme le popup - couvre aussi bien un clic
					// direct sur un jour du calendrier que Today/Tomorrow (qui
					// appellent instance.setDate(..., true) plus bas, donc
					// declenchent ce meme onChange).
					const $whenPopup = $(el).closest('.__modal_when_popup');
					if ($whenPopup.length && selectedDates[0]) {
						const $toggle = $(`.__modal_when_toggle[aria-controls="${$whenPopup.attr('id')}"]`);
						$toggle.find('.__modal_field_text').text(dateStr);
						$whenPopup.removeClass('_show');
						$toggle.removeClass('_open').attr('aria-expanded', 'false');
					}

					this.updateMobileModalSearchButton();
					this.updateSearchRecap();

					if (selectedDates[0]) {
						this.activateNextMobileSearchPanel(env, 'participants');
					}
				}
			});
		});
	},

	calendarSearch() {
		const today = new Date();
		const tomorrow = new Date();
		tomorrow.setDate(today.getDate() + 1);

		$(document).on('click', '._choose_date', e => {
			const $btn = $(e.currentTarget);
			const env = $btn.parent().data('env');

			this.container = this.getContainer(env);

			this.container.find('._choose_date').removeClass('_activ');
			$btn.addClass('_activ');
			this.container.find('._btn_plus').removeClass('_no_valid _activ');

			const type = $btn.data('date');
			const chosenDate = type === 'tomorrow' ? tomorrow : today;

			let instance = null;
			this.calendar_module.forEach(item => {
				if (item.type === env) {
					instance = item.instance;
				}
			});

			if (!instance) return;

			instance.setDate(chosenDate, true);

			const formatted = dayjs(chosenDate).format('MMM DD, YYYY');
			this.container.find(`#${this.calendar_id}`).val(formatted);
			this.container.find('input[name=date_deb]').val(dayjs(chosenDate).format('YYYY-MM-DD'));
			$('._calendar_inline').hide();
			$('#modal_search_calendar').removeClass('_show');
		});

		$(document).on('click', '._btn_plus:not(._no_valid)', e => {
			const $btn = $(e.currentTarget);
			const env = $btn.data('env');

			this.container = this.getContainer(env);
			this.container.find('._btn_plus').removeClass('_activ');
			$btn.addClass('_activ');

			const addDays = $btn.data('plus');
			let firstDate = null;

			this.calendar_module.forEach(item => {
				if (item.type === env) {
					firstDate = item.instance.selectedDates[0];
				}
			});

			if (!firstDate) return;

			const nextDay = dayjs(firstDate).add(addDays, 'day');
			const rangeStr = `${dayjs(firstDate).format('MMM DD')} - ${nextDay.format('MMM DD, YYYY')}`;

			this.container.find(`#${this.calendar_id}`).val(rangeStr);
			this.container.find('input[name=date_end]').val(nextDay.format('YYYY-MM-DD'));
		});

		$(document).on('click', 'input[name=__search_date]', e => {
			this.calendar_id = $(e.currentTarget).attr('id');
			$(e.currentTarget).next().next().show();
		});

		$(document).on('click', '.__close_calendar', () => {
			$('._calendar_inline').hide();
		});

		$(document).on('click', '._btn_clear', e => {
			const env = $(e.currentTarget).data('env');
			this.container = this.getContainer(env);
			this.clearCalendar(env);
		});

		$(window).on('click', event => {
			if (
				!$(event.target).closest('._calendar_inline, input[name=__search_date], #modal_search_mobile').length
			) {
				$('._calendar_inline').hide();
			}
		});
	},

	participantsControl() {
		$(document).on('click', '.__ophorus_search_module .__participants .__btn:not(._inactiv)', e => {
			e.preventDefault();

			const $btn = $(e.currentTarget);
			const $wrap = $btn.closest('.__participants');
			const $module = $btn.closest('.__ophorus_search_module');
			const isPlus = $btn.hasClass('_plus');

			let value = parseInt($wrap.data('value'), 10) || 1;
			value = isPlus ? Math.min(value + 1, 9) : Math.max(value - 1, 1);
			$wrap.data('value', value);

			const $list = $wrap.find('._number ._list');
			gsap.to($list, {duration: .3, y: -(value - 1) * 40, ease: 'power2.out'});

			$wrap.find('.__btn._minus').toggleClass('_inactiv', value <= 1);

			$module.find('input[name=__search_participants]').val(value);
		});
	},

	participantsFieldControl() {
		$(document).on('click', '._participants_field .__step_btn:not(._inactiv)', e => {
			e.preventDefault();

			const $btn = $(e.currentTarget);
			const $field = $btn.closest('._participants_field');
			const $hidden = $field.find('input[name=__search_participants]');
			const isPlus = $btn.hasClass('_plus');

			let value = parseInt($hidden.val(), 10) || 2;
			value = isPlus ? Math.min(value + 1, 8) : Math.max(value - 1, 2);
			$hidden.val(value);

			$field.find('._step_number').text(value);
			$field.find('._step_word').text(value > 1 ? 'Participants' : 'Participant');
			$field.find('.__step_btn._minus').toggleClass('_inactiv', value <= 2);

			// ._participants_field peut vivre dans une modal separee du vrai
			// formulaire cible (.__ophorus_search_module.{env}, celui que
			// check()/submit() lisent) : on y resynchronise la valeur.
			const env = $field.data('env');
			if (env) {
				this.getContainer(env).find('input[name=__search_participants]').val(value);
			}

			this.updateSearchRecap();
			this.activateNextMobileSearchPanel(env, 'type');
		});
	},

	clearCalendar(env) {
		this.calendar_module.forEach(item => {
			if (item.type === env) {
				item.instance.clear();
			}
		});

		this.container = this.getContainer(env);
		this.container.find('input[name=__search_date], input[name=date_deb], input[name=date_end]').val('');
		this.container.find('._btn_plus, ._choose_date').removeClass('_activ _no_valid');
	},

	check(isMobile, type) {
		if (isMobile) {
			const date = $('input[name=__search_date]').val();
			const dest = $('input[name=__search_destination]').val();
			return date || dest;
		}

		this.container = this.getContainer(type);

		const dest = this.container.find('input[name=destination_id]').val();
		const cat = this.container.find('input[name=category_id]').val();
		const date = this.container.find('input[name=date_deb]').val();
		const part = this.container.find('input[name=__search_participants]').val();
		const cats = this.container.find("input[name='category[]']:checked").length;
		const types = this.container.find("input[name='type[]']:checked").length;

		return dest || date || part || cat || cats || types;
	},

	submit(isMobile, isModule) {
		$('._calendar_inline').hide();
		const c = this.container;

		const postData = isMobile
			? {
				category_id: $('input[name=category_id]').val(),
				dest_id: $('input[name=destination_id]').val(),
				dest_type: $('input[name=destination_type]').val(),
				date_deb: $('input[name=__search_date]').val(),
				date_end: '',
				participants: ''
			}
			: {
				category_id: c.find('input[name=category_id]').val(),
				dest_id: c.find('input[name=destination_id]').val(),
				dest_type: c.find('input[name=destination_type]').val(),
				date_deb: c.find('input[name=date_deb]').val(),
				date_end: c.find('input[name=date_end]').val(),
				participants: isModule
					? c.find('input[name=__search_participants_module]').val()
					: c.find('input[name=__search_participants]').val(),
				type: c.find("form[name=_form_search] input[name='type[]']:checked").map(function () {
					return this.value;
				}).get()
			};

		if (!isMobile) {
			this.saveLastSearch({
				...postData,
				destination_title: c.find('input[name=__search_destination]').val() || ''
			});
		}

		$.post(`${_SITE_URL}search`, postData, session => {
			if (session === 'empty') {
				if (isMobile) {
					alert('No results with these criteria');
				} else {
					c.find('._search_empty').addClass('_show');
					setTimeout(() => c.find('._search_empty').removeClass('_show'), 3000);
				}
			} else {
				location.href = `${_SITE_URL}${session}`;
			}
		});
	}
};

export default search;
